module.exports = __webpack_public_path__ + "static/media/shoppingcar.91da0888.jpg";